(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["peppi-home-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('peppi-product-rail')) {
  customElements.define('peppi-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pp-rail__track');
      if (!this.track || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.controls = this.querySelector('.pp-rail__controls');
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.update = () => {
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = overflow < 2;
        this.previous.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft >= overflow - 2;
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (!button || !this.contains(button)) return;
        const card = this.track.querySelector('.pp-rail__item');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({left: step * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal});
      this.track.addEventListener('scroll', this.update, {passive:true, signal});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
